import React, { useEffect, useState } from 'react';
import { KiteIcon } from '@kite/react-kite';
import './NewsroomArticleAsideSocialMediaLinks.scss';
import { AnalyticsController } from '../../Analytics';
import { socialMediaLinks } from './constant';
import { addDomainName } from '../../../shared/domainNames';
const iconSize = `2rem`;

export const NewsroomArticleAsideSocialMediaLinks = ({
    node,
    className,
    isPolicy,
}: {
    node: any;
    className?: string;
    isPolicy?: boolean;
}) => {
    const [copyText, setCopyText] = useState(``);

    const [url, setUrl] = useState<URL>();

    useEffect(() => {
        const urlHref = new URL(window.location.href);
        setUrl(urlHref);
    }, []);

    const handleOnClick = (
        media: `facebook` | `twitter` | `linkedin` | `email` | `copy`
    ) => {
        AnalyticsController.track({
            event: `social share`,
            shareType: media,
            articleName: node.title,
        });
    };

    return (
        <ul className={`social-icons${className ? ` ${className}` : ``}`}>
            <li>
                <a
                    href={`${socialMediaLinks.linkedin}${addDomainName(
                        isPolicy
                    )}${url?.pathname ? url.pathname : ``}`}
                    onClick={() => handleOnClick(`linkedin`)}
                    target="blank"
                >
                    <span>Share on Linkedin</span>
                    <KiteIcon
                        icon="ki-linkedin"
                        size={iconSize}
                        title="Linkedin"
                    />
                </a>
            </li>
            <li>
                <a
                    href={`${socialMediaLinks.twitter}${addDomainName(
                        isPolicy
                    )}${url?.pathname ? url.pathname : ``}&via=${
                        isPolicy ? `CharterGov` : `charternewsroom`
                    }&text=${encodeURIComponent(node.title)}`}
                    onClick={() => handleOnClick(`twitter`)}
                    target="blank"
                >
                    <span>Share on X</span>
                    <KiteIcon icon="ki-x-twitter" size={iconSize} title="X" />
                </a>
            </li>
            <li>
                <a
                    href={`${socialMediaLinks.facebook}${addDomainName(
                        isPolicy
                    )}${url?.pathname ? url.pathname : ``}`}
                    onClick={() => handleOnClick(`facebook`)}
                    target="blank"
                >
                    <span>Share on Facebook</span>
                    <KiteIcon
                        icon="ki-facebook"
                        size={iconSize}
                        title="Facebook"
                    />
                </a>
            </li>
            <li>
                <a
                    href={`mailto:?body=${url}&subject=${encodeURIComponent(
                        node.title
                    )}`}
                    onClick={() => handleOnClick(`email`)}
                >
                    <span>Share via email</span>
                    <KiteIcon icon="ki-mail-f" size={iconSize} title="Email" />
                </a>
            </li>
            <li>
                <button
                    type="button"
                    onClick={() => {
                        if (
                            navigator &&
                            navigator.clipboard &&
                            navigator.clipboard.writeText
                        ) {
                            if (navigator.clipboard.writeText(url.toString())) {
                                setCopyText(`Copied URL`);

                                handleOnClick(`copy`);
                            } else {
                                setCopyText(`Could not copy.`);
                            }
                        } else {
                            setCopyText(`Could not copy.`);
                        }
                        setTimeout(() => {
                            setCopyText(``);
                        }, 3000);
                    }}
                >
                    <span>Copy article web url</span>
                    <KiteIcon icon="ki-link" size={iconSize} title="Copy URL" />
                </button>
                <div className="tooltip" hidden={!copyText}>
                    {copyText}
                </div>
            </li>
        </ul>
    );
};
